import '../styles/common.css';
import { useState } from 'react';
import OPPop from './OPPop';

// 瓷品项接口
interface PorcelainItem {
    id: number;
}

// 范围校验函数（修正无效输入）
const validateRange = (start: number, end: number) => {
    const validStart = Math.max(1, Math.min(start, end)); // 起始值不小于1且不大于结束值
    const validEnd = Math.max(validStart, end); // 结束值不小于起始值
    return { start: validStart, end: validEnd };
};

// 生成指定范围的瓷品数据
const generateRangeData = (start: number, end: number): PorcelainItem[] => {
    const { start: validStart, end: validEnd } = validateRange(start, end);
    return Array.from({
        length: validEnd - validStart + 1
    }, (_, i) => ({ id: validStart + i }));
};

// 默认范围配置
const DEFAULT_LEFT_RANGE = { start: 1, end: 42 };
const DEFAULT_RIGHT_RANGE = { start: 43, end: 83 };

interface OverviewPorcelainProps {
    type: 1 | 2; // 1代表原OverviewPorcelain样式，2代表原OverviewPorcelainColor样式
}

export default function OverviewPorcelain({ type }: OverviewPorcelainProps) {
    // 状态管理：选中项、左右范围
    const [selectedItem, setSelectedItem] = useState<PorcelainItem | null>(null);
    // 若后续代码确实不需要修改 leftRange 状态，可仅获取初始值
    const leftRange = DEFAULT_LEFT_RANGE;
    // 由于 setRightRange 从未被使用，只需要获取初始值即可
    const rightRange = DEFAULT_RIGHT_RANGE;

    // 生成左右数据（确保非空）
    const leftData = generateRangeData(leftRange.start, leftRange.end);
    const rightData = generateRangeData(rightRange.start, rightRange.end);

    // 根据type动态生成样式类
    const sideClass = type === 1 ? 'op' : 'opc';

    return (
        <div className={`${sideClass}-base`}>
            {/* OPPop弹窗 */}
            {selectedItem && (
                <OPPop
                    appId={type} // type=1对应appId=1，type=2对应appId=2
                    popId={selectedItem.id}
                    onClose={() => setSelectedItem(null)}
                />
            )}

            {/* 左侧网格（7行×6列=42个） */}
            <div className={`${sideClass}-left`} style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', columnGap: '0px' }}>
                {[...Array(42)].map((_, index) => {
                    const item = leftData[index];
                    return item ? (
                        <div
                            key={`right-${index}`}
                            className={`${sideClass}-col`}
                            onClick={() => setSelectedItem(item)}
                            style={{
                                width: '100%',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                opacity: 1
                            }}
                        >
                            <img
                                src={new URL(`../assets/images/op/a${item.id}.webp`, import.meta.url).href}
                                className="w-full h-auto"
                            />
                            <div className={`${sideClass}-con`}></div>
                        </div>
                    ) : null;
                })}
            </div>

            {/* 右侧网格（7行×6列=42个） */}
            <div className={`${sideClass}-right`} style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', columnGap: '0px' }}>
                {[...Array(42)].map((_, index) => {
                    const item = rightData[index];
                    return item ? (
                        <div
                            key={`right-${index}`}
                            className={`${sideClass}-col`}
                            onClick={() => setSelectedItem(item)}
                            style={{
                                width: '100%',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                opacity: 1
                            }}
                        >
                            <img
                                src={new URL(`../assets/images/op/a${item.id}.webp`, import.meta.url).href}
                                className="w-full h-auto"
                            />
                            <div className={`${sideClass}-con`}></div>
                        </div>
                    ) : null;
                })}
            </div>
        </div>
    );
}

// 移除原OverviewPorcelainColor组件文件（d:\Mizar\famous-porcelain\src\components\OverviewPorcelainColor.tsx）